import React from "react";

const chunkLoadPatterns = [
	/ChunkLoadError/i,
	/Loading chunk [\d]+ failed/i,
	/Loading CSS chunk [\d]+ failed/i,
	/Failed to fetch dynamically imported module/i,
	/Importing a module script failed/i,
];

function isChunkLoadError(error) {
	const message = `${error?.name || ""} ${error?.message || ""}`;
	return chunkLoadPatterns.some((pattern) => pattern.test(message));
}

export default class ChunkLoadErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, info) {
		// 永遠把完整堆疊丟到 console:錯誤頁只有一句「請重新整理」,使用者回報時
		// 根本無從定位(2026-10-01 官網嵌入最後一頁出現此頁,headless 重現不了)。
		// eslint-disable-next-line no-console
		console.error("[ChunkLoadErrorBoundary]", error, info?.componentStack);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
			this.setState({ error: null });
		}
	}

	render() {
		const { error } = this.state;
		if (!error) return this.props.children;

		const isChunkError = isChunkLoadError(error);
		const host = typeof window !== "undefined" ? window.location.hostname : "";
		const showDetails =
			host.startsWith("dev-") || host === "localhost" || host === "127.0.0.1" ||
			(typeof window !== "undefined" && /[?&]debug=1/.test(window.location.hash + window.location.search));
		const message = isChunkError
			? "頁面資源已更新或載入失敗，請重新整理後再試。"
			: "頁面載入時發生錯誤，請重新整理後再試。";

		return (
			<div
				role="alert"
				style={{
					minHeight: "240px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "12px",
					padding: "24px",
					textAlign: "center",
					color: "#1f2933",
				}}
			>
				<div style={{ fontSize: "16px", fontWeight: 700 }}>{message}</div>
				{/* dev 網域與本機才顯示細節:正式站不把內部堆疊露給使用者 */}
				{showDetails && (
					<pre
						style={{
							maxWidth: "720px",
							whiteSpace: "pre-wrap",
							textAlign: "left",
							fontSize: "12px",
							color: "#b42318",
							background: "#fff5f5",
							border: "1px solid #f3c2c2",
							padding: "8px 12px",
							margin: 0,
						}}
					>
						{`${error?.name || "Error"}: ${error?.message || ""}\n${String(error?.stack || "").split("\n").slice(1, 4).join("\n")}`}
					</pre>
				)}
				<button
					type="button"
					onClick={() => window.location.reload()}
					style={{
						border: "1px solid #1f2933",
						background: "#fff",
						color: "#1f2933",
						padding: "8px 14px",
						cursor: "pointer",
					}}
				>
					重新整理
				</button>
			</div>
		);
	}
}
